/* eslint-disable @typescript-eslint/naming-convention */
import Intercom from '@intercom/messenger-js-sdk';
function RootIntercom(params) {
    var _a;
    Intercom({
        app_id: params.intercomAppId,
        user_id: `${params.tenantId}_${params.userEmail}`,
        name: params.userName,
        email: params.userEmail,
        created_at: params.userCreatedAt,
        intercom_user_jwt: params.intercomUserJwt,
        hide_default_launcher: (_a = params.hideDefaultLauncher) !== null && _a !== void 0 ? _a : false
    });
    return null;
}
export default RootIntercom;
